<template>
    <div class="loads" v-can="'loads.access'" v-if="isMounted">
        <no-data v-if="!Object.keys(this.template).length"></no-data>

        <div v-else>
            <validation-observer ref="form" v-slot="{handleSubmit, invalid}">
                <vs-row class="mb-6">
                    <vs-col
                        vs-w="12"
                        vs-sm="4"
                        vs-lg="3"
                        vs-xs="12"
                        v-for="(value, key) in template"
                    >
                        <div class="m-2">
                            <vs-button
                                class="w-full"
                                :color="key === selectedTemplate ? 'success' : 'primary'"
                                type="filled"
                                @click="changeTemplate(key)"
                                :disabled="isLoaded"
                            >
                                {{ $t(`loads.${key}`) }}
                            </vs-button>
                        </div>
                    </vs-col>
                </vs-row>

                <filter-fields class="loads__card" @refresh="refreshFilter" :hide-btn="false">
                    <vs-row vs-align="flex-end">
                        <vs-col
                            vs-w="12"
                            vs-sm="6"
                            vs-lg="3"
                            vs-xs="12"
                        >
                            <div class="m-2">
                                <label class="text-sm opacity-75"><b>{{ $t('global.Send_date') }}</b></label>
                                <date-picker
                                    class="date"
                                    :date="date"
                                    direction="send_date"
                                    @select="selectDate"
                                />
                            </div>
                        </vs-col>
                        <vs-col
                            vs-w="12"
                            vs-sm="6"
                            vs-lg="3"
                            vs-xs="12"
                            v-for="(value, key) in filters"
                            :key="key"
                            v-if="template[selectedTemplate].includes(key)"
                        >
                            <div class="flex items-end w-full">
                                <div class="mb-5"
                                     v-if="key === 'statuses' && selectedTemplate === 'statuses'"
                                >
                                    <vs-checkbox
                                        v-model="allStatuses"
                                        v-tooltip="$t('tooltip.allStatuses')"
                                        @change="changeAllStatuses"
                                    />
                                </div>

                                <validation-provider
                                    class="w-full"
                                    :vid="key"
                                    :name="$t(`table_filters.${key}`)"
                                    :rules="{required: key === 'statuses' && !allStatuses}"
                                    v-slot="{ errors }"
                                >
                                    <div class="p-2 w-full" :class="{errorClass: errors[0]}">
                                        <div class="flex">
                                            <label class="text-sm opacity-75">
                                                <b>{{ $t(`table_filters.${key}`) }}</b>
                                            </label>
                                            <vs-icon
                                                v-if="errors[0]"
                                                class="ml-2"
                                                icon-pack="feather"
                                                icon="icon-alert-circle"
                                                color="danger"
                                                v-tooltip="errors[0]"
                                            ></vs-icon>
                                        </div>
                                        <v-select
                                            :options="value"
                                            :reduce="i => i.id || i"
                                            label="name"
                                            :closeOnSelect="false"
                                            multiple
                                            :name="key"
                                            :clearable="false"
                                            :clearSearchOnSelect="true"
                                            autocomplete
                                            v-model="selectedFilters[key]"
                                            @input="changeSelect(key)"
                                        />
                                    </div>
                                </validation-provider>
                            </div>
                        </vs-col>
                        <vs-col vs-w="12">
                            <div class="m-2 flex items-center justify-between">
                                <div>
                                    <vs-checkbox
                                        v-if="selectedTemplate === 'statuses'"
                                        v-model="selectedFilters.comments"
                                    >{{$t('modals.Lead_comments')}}</vs-checkbox>
                                </div>

                                <div class="flex justify-end mt-4 items-center">
                                    <vs-button
                                        color="primary"
                                        @click="handleSubmit(submitFilter)"
                                        :disabled="invalid"
                                        type="filled"
                                        icon-pack="feather"
                                        icon="icon-download"
                                    >
                                        {{ $t('buttons.downloadReport') }}
                                    </vs-button>
                                </div>
                            </div>
                        </vs-col>
                    </vs-row>
                </filter-fields>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler";
import send from "@/utils/fetch";
import vSelect from "vue-select";
import {download} from '@/utils/utils'
import {checkPermission, utils} from '@/utils/mixins'

export default {
    mixins: [checkPermission, utils],

    data() {
        return {
            isMounted: false,
            isLoaded: false,
            date: {
                startDate: new Date(),
                endDate: new Date()
            },
            filters: {},
            selectedFilters: {},
            selectedTemplate: 'deposits',
            allStatuses: false,
            template: {
                deposits: ['teams'],
                overpayment: ['teams'],
                statuses: ['teams', 'manager_id', 'statuses'],
                statuses_count: ['teams', 'statuses'],
            }
        }
    },

    components: {
        vSelect
    },

    watch: {
        selectedTemplate() {
            this.refreshFilter(true)
        },
    },

    methods: {
        changeSelect(key) {
            if (key === 'statuses' && this.selectedTemplate === 'statuses') {
                this.allStatuses = (this.selectedFilters.statuses || []).length === this.filters.statuses.length
            }
        },

        changeAllStatuses() {
            if (this.allStatuses) {
                this.selectedFilters.statuses = Object.values(this.filters.statuses)
            }
        },

        sortData(a, b) {
            return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
        },

        refreshFilter(bool) {
            if (!bool) {
                this.date.startDate = new Date()
                this.date.endDate = new Date()
                this.selectedFilters = {}
            }
            this.allStatuses = false

            this.$refs.form.reset()
        },

        dateParse(date) {
            return new Date(date)
                .toLocaleString('ru')
                .split(',')[0]
                .split('.')
                .reverse()
                .join('-')
        },

        changeTemplate(key) {
            this.selectedTemplate = key

            Object.keys(this.selectedFilters).map(k => {
                if (!this.template[this.selectedTemplate].includes(k)) {
                    delete this.selectedFilters[k]
                }
            })
        },

        selectDate(date) {
            this.date.startDate = date.startDate
            this.date.endDate = date.endDate
        },

        async submitFilter() {
            try {
                const isValid = await this.$refs.form.validate()
                if (isValid) {
                    this.isLoaded = true
                    const transform = {
                        teams: 'team_id',
                        statuses: 'status',
                        manager_id: 'manager_id',
                        comments: 'comments'
                    }

                    const commentsRequired = ['statuses']
                    if (!this.selectedFilters.hasOwnProperty('comments') && commentsRequired.includes(this.selectedTemplate)) {
                        this.selectedFilters.comments = false
                    }

                    const data = {
                        start: this.dateParse(this.date.startDate),
                        end: this.dateParse(this.date.endDate),
                        ...Object.entries(this.selectedFilters).reduce((res, [key, value]) => {
                            res[transform[key]] = value
                            return res
                        }, {})
                    }

                    const response = await send(this.$url.loads[this.selectedTemplate], 'POST', {data}, false)
                        .then(response => response.data)

                    if (response) {
                        const name = `${data.start}_${data.end}_${this.selectedTemplate}.csv`

                        download(response, name, 'text/csv')

                        this.$vs.notify({
                            title: 'Success',
                            text: name,
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                    } else {
                        this.$vs.notify({
                            title: this.$t('global.No_data'),
                            text: this.$t('global.No_data'),
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                    }

                    this.$refs.form.reset()
                }
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.isLoaded = false
            }
        },

        mutationsTeams(data) {
            return Object.entries(data).reduce((res, [id, name]) => {
                res.push({id: ~~id, name: name.toString()})
                return res
            }, [])
        },

        mutationsManagers(data) {
            const list = Object.entries(data).reduce((res, [name, id]) => {
                res.push({name, id})

                return res
            }, [])

            return list.sort(this.sortData)
        },

        templateList() {
            return Object.entries(this.template).reduce((res, [key, value]) => {
                if (this.isPermission(`loads.${key}`)) res[key] = value
                return res
            }, {})
        }
    },

    async mounted() {
        try {
            this.template = this.templateList()
            this.selectedTemplate = Object.keys(this.template)[0]

            const response = await send(this.$url.loads.get, 'GET')
                .then(response => response.data.result)

            this.filters = {
                teams: this.createNameById(this.mutationsTeams(response.teams)),
                manager_id: response.managers ? this.mutationsManagers(response.managers) : [],
                statuses: Object.values(response.statuses)
            }

            if (!response.managers) delete this.filters.manager_id

            this.filters.statuses = Object.values(response.statuses).sort((a, b) => {
                return a < b ? -1 : 1
            })

            this.isMounted = true
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.loads {
    .errorClass {
        color: rgba(var(--vs-danger), 1);

        .vs__dropdown-toggle {
            border-color: rgba(var(--vs-danger), 1);

            input {
                color: rgba(var(--vs-danger), 1);
            }
        }
    }

    &__card {
        background-color: white;
        padding: 20px;
        border-radius: 0.5rem;
    }
}
</style>
